import API from 'app/utils/apiClient';


const report = (objectType, objectId, reason, category) =>
  API.post('/reports/', {
    objectType,
    objectId,
    reason,
    category,
  });

const getReportCategories = () => API.get('/report-categories/');

export default {
  report,
  getReportCategories,
};



// WEBPACK FOOTER //
// ./src/app/apis/report.js